import { useState } from "react";
import axios from "axios";
import translate from "i18n/translate";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";
import { ACCOUNT } from "../../../constants/api";

const useSecurity = () => {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const intl = useIntl();

  const changePassword = async (
    { currentPassword, newPassword },
    { resetForm }
  ) => {
    setSubmitting(true);
    setError("");

    try {
      await axios.post(ACCOUNT, {
        password: currentPassword,
        newPassword,
      });

      resetForm();
      toast.success(intl.formatMessage({ id: "common.saveSuccess" }));
    } catch (err) {
      setError(
        err.response?.data?.error?.message || translate("errors.somethingWrong")
      );
    } finally {
      setSubmitting(false);
    }
  };

  return {
    submitting,
    error,
    changePassword,
  };
};

export default useSecurity;
